export type SubscriptionDetails = {
  subscription: any
  portal_url: string
}

export enum Plan {
  UNLIMITED = "Unlimited",
  PAY_AS_YOU_GO = "PayAsYouGo"
}
